// rome-ignore lint/suspicious/noExplicitAny: Came from AWS Amplify Documentation
(window as any).global = window;
// rome-ignore lint/suspicious/noExplicitAny: Came from AWS Amplify Documentation
(window as any).process = {
  env: { DEBUG: undefined },
};
